import { connect } from 'react-redux'
import AlertLJ from "../../components/AlertLJ"
import { alertSuccess, alertError, clearAlert } from "../../actions/alertlj"

const mapStateToProps = (state, ownProps) => {
  return {
  	message: state.alertlj.message,
  	type: state.alertlj.type,
  	visible: state.alertlj.visible,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
		onShowAlertSuccess: (message) => dispatch(showAlertSuccess(message)),
		onShowAlertError: (message) => dispatch(showAlertError(message)),
		onClearAlert: () => dispatch(clearAlert())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AlertLJ)



// WEBPACK FOOTER //
// ./src/containers/AlertLJ/index.js